import { save } from '../engine/SaveSystem';

export class MainMenu {
  readonly el: HTMLElement;
  onNewGame?: () => void;
  onContinue?: () => void;

  constructor(root: HTMLElement) {
    this.el = document.createElement('div');
    this.el.className = 'overlay';
    this.el.innerHTML = `
      <div class="panel" style="text-align:center">
        <div class="title-hero">🧚 Fairy Love</div>
        <p class="subtitle">A cozy afternoon among petals and pages.</p>
        <div class="menu-buttons">
          <button class="btn" data-action="new">New Game</button>
          <button class="btn secondary" data-action="continue">Continue</button>
        </div>
        <div class="controls-grid">
          <kbd>WASD</kbd><span>Move</span>
          <kbd>Mouse</kbd><span>Look around</span>
          <kbd>Space</kbd><span>Jump · tap midair to fly · hold to ascend</span>
          <kbd>Shift</kbd><span>Sprint · descend while flying</span>
          <kbd>E</kbd><span>Interact with landmarks</span>
          <kbd>B</kbd><span>Build mode (in your cottage)</span>
          <kbd>Esc</kbd><span>Menu</span>
        </div>
      </div>
    `;
    root.appendChild(this.el);

    const btnNew = this.el.querySelector('[data-action="new"]') as HTMLButtonElement;
    const btnCont = this.el.querySelector('[data-action="continue"]') as HTMLButtonElement;
    btnCont.disabled = !save.exists();
    btnNew.addEventListener('click', () => this.onNewGame?.());
    btnCont.addEventListener('click', () => this.onContinue?.());
  }

  show(): void {
    const btnCont = this.el.querySelector('[data-action="continue"]') as HTMLButtonElement;
    btnCont.disabled = !save.exists();
    this.el.classList.remove('hidden');
  }
  hide(): void { this.el.classList.add('hidden'); }
}
